import DatePicker from "components/foundation/DatePicker";
import DocumentTextField from "components/foundation/DocumentTextField/DocumentTextField";
import React, { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import CreateDocumentForm from "../../CreateDocumentForm";
import CreateDocumentClassFormBody from "../CreateDocumentClassFormBody";
import { TempDocumentDetailResponseWithAny } from "features/document/hooks/queries/useTempDocumentDetailQuery";
import { SEND_OFFICIAL_LETTER_FIELD as FIELD } from "config/documentConstant";
import formatMinMaxLengthMessage from "utils/formatUtils/formatMinMaxLengthMessage";
import { selectedWorkCompanyState } from "store/document/workDocument";
import { useRecoilValue } from "recoil";

/* 공문 발신 */
interface SendOfficialLetterForm {
  [FIELD.DOCUMENT_SEND_NUMBER.key]: string;
  [FIELD.RECEIVER.key]: string;
  [FIELD.REGISTRATION_DATE.key]: string;
  [FIELD.TITLE.key]: string;
}

interface SendOfficialLetterProps {
  tempDocumentDetail?: TempDocumentDetailResponseWithAny;
}

const SendOfficialLetter = ({
  tempDocumentDetail,
}: SendOfficialLetterProps) => {
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext<SendOfficialLetterForm>();

  const company = useRecoilValue(selectedWorkCompanyState);

  useEffect(() => {
    setValue(FIELD.DOCUMENT_SEND_NUMBER.key, company?.uuid || "");
  }, []);
  // 공문 수신번호를 생성하기 위한 공문 수신 번호 필드는 삭제되었지만 백앤드 로직은 똑같기 때문에 API req 필드에는 그대로 남겨둠

  return (
    <CreateDocumentClassFormBody noBorderTop>
      <CreateDocumentForm.Field label={FIELD.RECEIVER.label}>
        <DocumentTextField
          placeholder="수신자명을 입력해 주세요."
          {...register(FIELD.RECEIVER.key, {
            required: "수신자 입력 필수",
            minLength: {
              value: FIELD.RECEIVER.minLength,
              message: formatMinMaxLengthMessage(
                FIELD.RECEIVER.minLength,
                FIELD.RECEIVER.maxLength,
              ),
            },
            maxLength: {
              value: FIELD.RECEIVER.maxLength,
              message: formatMinMaxLengthMessage(
                FIELD.RECEIVER.minLength,
                FIELD.RECEIVER.maxLength,
              ),
            },
          })}
          errorMessage={errors[FIELD.RECEIVER.key]?.message}
        />
      </CreateDocumentForm.Field>
      <CreateDocumentForm.Field label={FIELD.REGISTRATION_DATE.label}>
        <Controller
          name={FIELD.REGISTRATION_DATE.key}
          control={control}
          rules={{
            required: "발신일 선택 필수",
          }}
          render={({ field }) => (
            <DatePicker
              {...field}
              usage="document"
              placeholder="발신일을 선택해 주세요."
              defaultValue={
                tempDocumentDetail?.documentData?.[FIELD.REGISTRATION_DATE.key]
              }
              dateFormat={FIELD.REGISTRATION_DATE.dateFormat}
              onChangeDate={(_, dateString) => {
                field.onChange(dateString);
              }}
              errorMessage={errors[FIELD.REGISTRATION_DATE.key]?.message}
            />
          )}
        />
      </CreateDocumentForm.Field>
      <CreateDocumentForm.Field label={FIELD.TITLE.label}>
        <DocumentTextField
          {...register(FIELD.TITLE.key, {
            required: "제목 입력 필수",
            minLength: {
              value: FIELD.TITLE.minLength,
              message: formatMinMaxLengthMessage(
                FIELD.TITLE.minLength,
                FIELD.TITLE.maxLength,
              ),
            },
            maxLength: {
              value: FIELD.TITLE.maxLength,
              message: formatMinMaxLengthMessage(
                FIELD.TITLE.minLength,
                FIELD.TITLE.maxLength,
              ),
            },
          })}
          placeholder="제목을 입력해 주세요."
          errorMessage={errors[FIELD.TITLE.key]?.message}
        />
      </CreateDocumentForm.Field>
    </CreateDocumentClassFormBody>
  );
};

export default SendOfficialLetter;
